import { compileRulePattern, ruleHit } from '@hue/contracts';
import type { ClassificationRule, ClassificationRuleInput, RuleCandidate } from './api.js';

export function ruleTrials(
  draft: ClassificationRuleInput & { id: string; pattern: string; suspended?: boolean },
  rules: ClassificationRule[],
  candidates: RuleCandidate[],
) {
  const queue: Array<
    ClassificationRuleInput & {
      id: string;
      pattern: string;
      suspended: boolean;
    }
  > = rules.map((rule) =>
    rule.id === draft.id ? { ...rule, ...draft, suspended: draft.suspended ?? false } : rule,
  );
  if (!queue.some((rule) => rule.id === draft.id))
    queue.push({ ...draft, suspended: draft.suspended ?? false });
  const compiled = new Map(queue.map((rule) => [rule.id, compileRulePattern(rule.pattern)]));
  const hit = (rule: typeof draft, candidate: RuleCandidate) =>
    ruleHit({ ...rule, financeAccountId: null }, candidate, compiled.get(rule.id));
  return candidates
    .filter((candidate) => hit(draft, candidate))
    .map((candidate) => {
      const winner = queue.find((rule) => !rule.suspended && hit(rule, candidate));
      const effect =
        candidate.accountId !== null
          ? 'Já tem conta; aplicar aos sem conta preserva a classificação.'
          : winner?.id === draft.id
            ? 'Recebe a conta ao aplicar.'
            : winner
              ? `Outra regra tem prioridade: ${winner.name}.`
              : 'Regra suspensa; não recebe conta.';
      return { ...candidate, key: `${candidate.kind}:${candidate.key}`, effect };
    });
}
